import { render } from "./MenuCreationGroups-add.vue?vue&type=template&id=e88610fe"
import script from "./MenuCreationGroups-add.vue?vue&type=script&lang=js"
export * from "./MenuCreationGroups-add.vue?vue&type=script&lang=js"

import "./MenuCreationGroups-add.vue?vue&type=style&index=0&id=e88610fe&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__